import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

export function Login() {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, sessionExpired, clearSessionExpired } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    clearSessionExpired();
    setLoading(true);

    const result = await login(userId, password);
    setLoading(false);

    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white border border-gray-200 rounded-sm shadow-lg p-8">
          <div className="flex justify-center mb-8">
            <img 
              src="https://customer-assets.emergentagent.com/job_jo-management-hub/artifacts/nkm3gwix_image.png" 
              alt="Karthik Doors & Windows" 
              className="h-24"
            />
          </div>
          
          <h1 className="text-2xl font-bold tracking-tight text-gray-900 text-center mb-2">
            Karthik Doors & Windows
          </h1>
          <p className="text-sm text-gray-600 text-center mb-8">
            UPVC Job Order Management System
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            {sessionExpired && (
              <div className="bg-amber-50 text-amber-800 border border-amber-300 p-3 rounded-sm text-sm" data-testid="session-expired-message">
                Your session has expired due to inactivity. Please sign in again.
              </div>
            )}
            {error && (
              <div className="bg-red-50 text-red-700 border border-red-200 p-3 rounded-sm text-sm" data-testid="login-error">
                {error}
              </div>
            )}

            <div className="space-y-2">
              <Label htmlFor="user-id" className="text-sm font-bold uppercase tracking-[0.2em] text-gray-600">
                User ID
              </Label>
              <Input
                id="user-id"
                data-testid="login-user-id-input"
                type="text"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                required
                className="w-full h-11 border-gray-300"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="text-sm font-bold uppercase tracking-[0.2em] text-gray-600">
                Password
              </Label>
              <Input
                id="password"
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full h-11 border-gray-300"
              />
            </div>

            <Button
              data-testid="login-submit-button"
              type="submit"
              disabled={loading}
              className="w-full h-11 text-white font-bold"
              style={{ backgroundColor: '#FF6B35' }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#E85A2A'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#FF6B35'}
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </Button>
          </form>

          <div className="mt-6" />
        </div>
      </div>
    </div>
  );
}
